module.exports = __webpack_public_path__ + "img/wh.e461b69a.svg";